export const sliderItems = [
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1668541902735WhatsApp_Image_2022-11-08_at_10.24.50_PM-removebg-preview.png?alt=media&token=fa712aa6-d523-46ed-9e28-0ea808b01b6e",

    // img: "https://assets.ajio.com/medias/sys_master/root/20220818/22eZ/62fde1bdf997dd394c018b73/ivoc_olive_green_slim_fit_shirt_with_flap_pockets.jpg",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1668541646596WhatsApp_Image_2022-11-08_at_10.20.47_PM-removebg-preview.png?alt=media&token=8c313b92-3c2d-4bc3-9801-1783415c8f2f",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1667969032197WhatsApp%20Image%202022-11-08%20at%2010.22.32%20PM.jpeg?alt=media&token=dfb85a88-3f0d-4416-8b51-d4258547c1fd",
    title: "SHOES",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1667969533141Screenshot%202022-11-09%20102123.jpg?alt=media&token=cb5b133b-4aa0-4cee-b324-df4882ecb53d",
    title: "SHIRT STYLE!",
    cat: "shirt",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1667970278547the_indian_garage_co_green_textured_zip-front_jacket_with_insert_pockets.webp?alt=media&token=8e301e5b-7a8e-4b52-bedd-e4cd78aacfb8",
    title: "JACKET AND COAT",
    cat: "jacket",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-413fa.appspot.com/o/1668106925657WhatsApp%20Image%202022-11-08%20at%2010.24.22%20PM.jpeg?alt=media&token=025af095-467d-44a7-9248-b5f0de56d015",
    title: "JEANS",
    cat: "jeans",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 2,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id: 4,
    img: "https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
];
